module.exports = {
  title: '天擎管理系统',

  showSettings: false,

  tagsView: true,

  fixedHeader: false,

  sidebarLogo: false,

};
